import { ChangeDetectorRef, Component } from '@angular/core';
import { AdminService } from '../../admin.service';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { AdminItemContainerDirective } from '@app/main/admin/directives/admin-item-container.directive';
import { DialogService } from '@shared/services';
import { ModuleService } from '@shared/services/module.service';

@Component({
    selector: 'app-admin-responsible',
    templateUrl: './admin-responsible.component.html',
    styleUrls: ['./admin-responsible.component.scss'],
    animations: [
        trigger('comeUp', [
            state(
                'void',
                style({
                    opacity: 0
                })
            ),
            state(
                '*',
                style({
                    opacity: 1
                })
            ),
            transition('void => *', [animate(500)]),
            transition('* => void', [])
        ])
    ],
    standalone: false
})
export class AdminResponsibleComponent extends AdminItemContainerDirective {
    constructor(
        adminService: AdminService,
        dialogService: DialogService,
        changeDetector: ChangeDetectorRef,
        moduleService: ModuleService
    ) {
        super(changeDetector, adminService, dialogService, moduleService);
    }
}
